<template>
  <div class="logoff">
    <Head :title="title"></Head>
    <div class="img">
      <img src="@/assets/mylogin/gantanhao-2.png" alt="" />
    </div>
    <div class="texe">
      <p>用户注销规则</p>
      <div
        style="
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-top: 13px;
        "
      >
        账号注销后，您在平台所有的权益将被清空且
      </div>
      <div
        style="
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-top: 10px;
        "
      >
        如果您确定放弃账号，在提交注销申请前。需同时满足以下条件：
      </div>
      <div
        style="
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
        "
      >
        1、账号内资产已结清。您的账号不存在余额未提取。
        <br />
        2、账号近期不存在交易。您的账号无未完成订单。
        <br />
        3、账号已解除与第三方产品的绑定关系或授权登录关系。
        <br />
        4、账号不存在未完结的服务。您的账号不存在已提交但处于审核状态内容、已投稿但未完成投审稿全部流程等
      </div>
    </div>
    <div class="checkbox">
      <van-field name="checkbox" class="input_check">
        <template #input>
          <van-checkbox v-model="agree" shape="square">
            <template #icon="props">
              <img
                class="img-icon"
                :src="
                  props.checked
                    ? require('@/assets/img/login/l_sel.png')
                    : require('@/assets/img/login/l_unsel.png')
                "
              />
            </template>
            我已阅读并同意《<span
              style="color: #4266f5"
              @click="$router.push('/applogouttcp')"
              >用户注销协议</span
            >》</van-checkbox
          >
        </template>
      </van-field>
    </div>
    <div style="margin: 10px 0 20px; width: 94%; margin: 20px auto">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        class="form_btn"
        :disabled="!agree"
        @click="getCode"
        >下一步</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Head from "../components/headTabs.vue";
export default {
  name: "logoff",
  components: {
    Head,
  },
  data() {
    return {
      title: "申请注销账号",
      agree: false,
      disabled: true,
      phone: "",
    };
  },
  mounted() {
    this.phone = JSON.parse(sessionStorage.getItem("userInfo")).user.username;
  },
  methods: {
    async getCode() {
      const res = await this.$apis.loginServe.getCode({
        phone: this.phone,
        adapter: "destroy",
      });
      if (res.resultCode == "200") {
        Toast("获取成功");
        this.$router.push("logoffCode");
      } else {
        Toast(res.resultDesc);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logoff {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #fff;
  .logoff_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 150px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      margin: 0 auto;
      text-align: center;
    }
  }
  .img {
    width: 40px;
    height: 40px;
    margin-top: 29px;
    margin: 29px auto;
    img {
      width: 40px;
      height: 40px;
    }
  }
  .texe {
    margin-left: 15px;
    overflow: hidden;
    p {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
  }
  .checkbox {
    .input_check {
      margin-top: 36px;
      background-color: unset;
      &::after {
        content: none !important;
      }
      .img-icon {
        width: 13px;
        height: 13px;
      }
    }
  }
}
</style>
